import { PERMISSION_TYPE } from 'constants/index';

const normalizePermissions = permissions => {
  if (typeof permissions?.isPresent === 'function') {
    return permissions;
  }

  const permArray = Array.isArray(permissions) ? permissions : permissions?.permArray ?? [];

  return {
    isPresent: permission => permArray.includes(permission),
    get: () => permArray,
  };
};

const buildPermissionFlags = rawPermissions => {
  const permissions = normalizePermissions(rawPermissions);
  const hasCreatePermission = permissions.isPresent(PERMISSION_TYPE.CREATE);
  const hasUpdatePermission = permissions.isPresent(PERMISSION_TYPE.UPDATE);
  const hasReadPermission = permissions.isPresent(PERMISSION_TYPE.READ);
  const hasDeletePermission = permissions.isPresent(PERMISSION_TYPE.DELETE);

  return {
    permissions,
    hasCreatePermission,
    hasUpdatePermission,
    hasReadPermission,
    hasDeletePermission,
    isPresent: permission => permissions.isPresent(permission),
  };
};

export default buildPermissionFlags;
